import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scTextFormatter'
})
export class TextFormatterPipe implements PipeTransform {

  transform(text: string,
    options: { prefix } = undefined
  ): string {

    let transformedText = this.handleDynamoWarning(text);

    if (options) {
      transformedText = this.handleOptions(transformedText, options);
    }

    return transformedText;
  }

  handleOptions(transformedText: string, options: { prefix }): string {

    let answer = transformedText;
    if (options.prefix) {
      answer = `${options.prefix}${transformedText}`;
    }

    return answer;
  }

  handleDynamoWarning(text: string): string {
    // Get position of a special character that
    // Dynamo sends with each warning message
    const startPosition = text.indexOf('/') + 1;
    // Return a clean warning message
    return text.substring(startPosition);
  }

}
